// extracted by mini-css-extract-plugin
export default {"fullWindow":"fullWindowModal_fullWindow__3AzxK","close":"fullWindowModal_close__ewDaq","icon":"fullWindowModal_icon__wLPc0","reallyFull":"fullWindowModal_reallyFull__rUVC2"};